import { Component } from '@angular/core';

//Services
import { AcukwikairportsService } from '../../../services/acukwikairports.service';

// Models
import { AirportFboGeoFenceGridViewmodel } from '../../../models/fbo-geofencing/airport-fbo-geo-fence-grid-viewmodel';

@Component({
    selector: 'app-fbo-geofencing-dialog-new-airport',
    styleUrls: ['./fbo-geofencing-dialog-new-airport.component.scss'],
    templateUrl: './fbo-geofencing-dialog-new-airport.component.html',
})
export class FboGeofencingDialogNewAirportComponent {

    // Populated by AppDialogWrapperComponent
    data: AirportFboGeoFenceGridViewmodel;
    dialogRef: { close: (result?: any) => void };

    constructor(
        private acukwikairportsService: AcukwikairportsService
    ) { }

    airportValueChanged(airport: any) {
        if (!this.data) {
            this.data = {} as AirportFboGeoFenceGridViewmodel;
        }
        this.data.icao = airport.icao;
        this.data.acukwikAirportId = airport.oid;
    }

    onCancelClick(): void {
        if (this.dialogRef) {
            this.dialogRef.close();
        }
    }

    onAddAirportClick(): void {
        if (this.dialogRef) {
            this.dialogRef.close(this.data);
        }
    }
}
